<template>
    <div class="scrolltop" ref="scrolltopElement">
        <i class="fal fa-arrow-up"></i>
    </div>
</template>

<script setup lang="ts">
    import { Ripple } from "@/shared/ui/Ripple";
    import { onMounted, ref } from "vue";

    const scrolltopElement = ref<HTMLElement | null>(null);

    onMounted(() => {
        Ripple.bind($(scrolltopElement.value!));
    });
</script>
